import placeHolder from "./assets/image-place-holder.png";

interface ImagePlaceHolderProps {
  className?: string;
}

const ImagePlaceHolder = ({ className }: ImagePlaceHolderProps) => (
  <img
    src={placeHolder}
    style={{ objectFit: "cover", width: "100%", height: "100%" }}
    alt="Placeholder"
    data-testid="image-placeholder"
    className={className}
  />
);

export default ImagePlaceHolder;
